import React from 'react';
import { Redirect, Route, BrowserRouter, Switch } from 'react-router-dom';

import { PATHS } from './common/constants';
import ServiceRequests from './pages/ServiceRequests';
import ServiceRequest from './pages/ServiceRequest';
import Settings from './pages/Settings/Settings';
import ChangePassword from './pages/ChangePassword/ChangePassword';

import ReactGA from 'react-ga4';
import { createBrowserHistory } from 'history';
import AdminRoutes from './Routes/AdminRoutes';
import AuthRoutes from './Routes/AuthRoutes';
import InboxContainer from './pages/Inbox/InboxContainer';
import VideoChat from './pages/VideoChat';
import HomeownerRoutes from './Routes/HomeownerRoutes';
import Request from './pages/Request/Request';

const history = createBrowserHistory();

history.listen(location => {
  ReactGA.set({ page: location.pathname }); // Update the user's current page
  ReactGA.pageview(location.pathname); // Record a pageview for the given page
});

function Router() {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.id) {
    const roleName = user.roles[0].role.name;
    if (roleName === "Service Manager" || roleName === "Service Provider") {
      return (
        <BrowserRouter>
          <Switch>
            <Route
              path={PATHS.SERVICE_REQUESTS_VIEW}
              component={ServiceRequest}
            />
            <Route
              path={PATHS.SERVICE_REQUESTS_LIST}
              component={ServiceRequests}
            />
            <Route
              path={PATHS.SETTINGS}
              component={Settings}
            />
             <Route
            path={PATHS.CHANGE_PASSWORD}
            component={ChangePassword}
          />
          <Route
            path={PATHS.VIDEO_CHAT}
            component={VideoChat}
          />
          <Route
            path={PATHS.INBOX}
            component={InboxContainer}
          />
            <Route
            path={PATHS.REQUEST}
            component={Request}
          />
            <Route path="/">
              <Redirect to={PATHS.SERVICE_REQUESTS_LIST} />
            </Route>
          </Switch>
        </BrowserRouter>
      )
      /*
        Created By: Sai Prasad
        Created Date: 23/08/2022 6:00 PM
        Description: implemented routes for homeowner and relator
      */
    } else if(roleName === "Home Owner" || roleName === "Realtor"  || roleName=="Occupant") {
      return (
        <HomeownerRoutes/>
        );
    } else {
      return (
        <AdminRoutes/>
        );
    }
  } else {
    return (
      <AuthRoutes />
    )
  }
}

export default Router;
